module.exports = __webpack_public_path__ + "static/media/inviteSuccess.c85b78c3.png";